import React from 'react'
import _get from 'lodash/get'
import _compact from 'lodash/compact'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import Promotion from '../Promotion/index'
import SectionGraphQLManager, { SECTION_TYPES } from '../SectionGraphQLManager/index'
import { get as getConfig } from '../../config/index'
import { createTitleGroupId } from '../../services/content/index'
import { EN } from '../../services/languages/constants'
import { getUserLanguagePrimary } from '../../services/user/index'
import { getBoundActions } from '../../actions/index'

const config = getConfig()
const promotionGraphQLActive = !!_get(config, ['features', 'promotionGraphQL'])

function SectionPromotion (props) {
  const {
    promotionContentId,
    promotionContentType,
    sectionId,
    history,
    sectionIndex,
    language,
    rowPlacement,
  } = props

  if (promotionGraphQLActive) {
    const titleGroupIds = _compact([createTitleGroupId(promotionContentId, promotionContentType)])

    if (titleGroupIds.length) {
      return (
        <SectionGraphQLManager
          language={language}
          titleGroupIds={titleGroupIds}
          sectionId={sectionId}
          history={history}
          sectionIndex={sectionIndex}
          rowPlacement={rowPlacement}
          sectionType={SECTION_TYPES.PROMOTION}
        />
      )
    }

    return null
  }

  return (
    <Promotion {...props} />
  )
}

export default compose(
  connectRedux(
    (state, props) => {
      const { user, pmSection } = state
      const { sectionId } = props
      // Tabs are in the union type data, so access data.data.tabs
      const promotionContentId = pmSection.getIn([sectionId, 'data', 'data', 'tabs', '0', 'tabContent', '0', 'contentId'])
      const promotionContentType = pmSection.getIn([sectionId, 'data', 'data', 'tabs', '0', 'tabContent', '0', 'contentType'])
      const language = getUserLanguagePrimary(user) || EN

      return {
        language,
        promotionContentId,
        promotionContentType,
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setUpstreamContext: actions.upstreamContext.setUpstreamContext,
        setEventDefault: actions.eventTracking.setEventDefault,
      }
    },
  ),
)(SectionPromotion)
